import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../../common/models/single-response.model';


import { LoanActionTypes , LoanActions, LoadLoansSuccess} from '../actions/loan.actions';
import { SummaryLoanModel } from '../../models/summary-loan.model';


export interface LoanState {
  items: SummaryLoanModel[];
  total: number;
  res: PaginableResponseModel<SummaryLoanModel>;
  selected: SingleResponseModel<SummaryLoanModel> | null;
  loading: boolean;
  error: any
}


export const initalState: LoanState = {
  items: [],
  total: 0,
  res: null,
  selected: null,
  loading: false,
  error: null
};

export function LoanReducer(
  state = initalState,
  action: LoanActions
): LoanState {

  switch (action.type) {
    case LoanActionTypes.LoadLoans:
      return { ...state, loading: true, error: null };

    case LoanActionTypes.LoadLoansSuccess:
      const { items, total } = (action as LoadLoansSuccess).payload;
           return {
             ...state,
             loading: false,
             error: null,
             items: items,
             total: total,
           };
    case LoanActionTypes.LoadLoansFailure:
      return{ ...state, loading: false, error: action.payload.error };


    case LoanActionTypes.LoadLoanSuccess:
      return {
        ...state,
        selected: action.payload
      };

    default:
      return state;
  }
}
